import {Component, OnInit, Injector, Output, EventEmitter} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {CARDINFO, SUBSCRIPTIONINFO} from '../../../../gen/swagger-api';
import {Subject} from 'rxjs/Subject';
import {ModalBaseComponent} from '../modal-base-component';
import {DefaultService} from '../../../../gen/swagger-api/api/default.service';

@Component({
  selector: 'app-select-msisdn',
  templateUrl: './select-msisdn.component.html',
  styleUrls: ['./select-msisdn.component.css']
})
export class SelectMsisdnComponent extends ModalBaseComponent implements OnInit {

  constructor(
    private inject: Injector,
    private _bsModalRef: BsModalRef,
    private defaultService: DefaultService
  ) {
    super(inject);
    this.options = new Subject<any>();
  }

  public options: Subject<any>;
  subscription: CARDINFO;
  subscriptionInfos: Array<SUBSCRIPTIONINFO>;
  selectedSubscriptionInfo: SUBSCRIPTIONINFO;
  allSelected = false;
  @Output() action = new EventEmitter();


  ngOnInit() {
    this.defaultService.cardsEidProfilesGet(this.subscription.eis.eid).subscribe(subscriptionInfos => {
      this.subscriptionInfos = subscriptionInfos;

      if (!this.allSelected) {
        this.subscriptionInfos.forEach(subscriptionInfo => {
          if (subscriptionInfo.status === 'ENABLED') {
            this.selectedSubscriptionInfo = subscriptionInfo;
          }
        });
      } else {
        this.allIsChecked('');
      }
    });


  }

  public allIsChecked(event) {
    this.selectedSubscriptionInfo = undefined;
    this.allSelected = true;
  }

  public unCheckAll() {
    this.allSelected = false;
  }

  public closeModal(): void {
    if (this.allSelected) {
      this.action.emit(true);
    }
    this._bsModalRef.hide();

  }

  public confirm(): void {
    if (this.allSelected) {
      this.action.emit(true);
    }
    this._bsModalRef.hide();
    this.options.next({
      selectedSubscriptionInfo: this.selectedSubscriptionInfo,
      allSelected: this.allSelected,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/select-msisdn/select-msisdn.component.ts